import React from 'react';
import {sportsKeyByName} from "../utils/constant";


const FencyPremuimTabController = ({isLoggedIn, eventT, handlefancypin, handlepremium, handleFancy, hideFancyTabBtn, hidePremiumBtn, fancypin, isActiveFancy, isActivePremium}) => {

    return (
        <>
            {isActiveFancy && (
                <div id="fancyBetHead" className="fancy_bet-head">
                    <h4 className="in-play">
                        <a id="multiMarketPin" onClick={handlefancypin} className={`pin${fancypin ? "-on" : "-off"}`}>Pin
                            to
                            Muilti Markets</a>
                        <span><pre>in-play</pre>
                            {eventT == sportsKeyByName.CRICKET ? "Fancy Bet" : " Election Fancy Bet"}</span>
                        <a className="btn-head_rules">Rules</a>
                    </h4>

                    {(eventT == sportsKeyByName.CRICKET &&  isLoggedIn === true && !hidePremiumBtn) &&
                        <a id="showSportsBookBtn" className="other-tab" onClick={handlepremium} style={{}}>
                            <span className="tag-new">New</span>
                            Premium Cricket
                        </a>}
                </div>
            )}
            {isActivePremium && (
                <div id="sportsBookHead" className="sportsbook_bet-head">
                    <h4 id="betHeader">
                <span id="sportsBookName">
                    <pre id="inPlayTag" style={{display: 'none'}}>in-play</pre>
                    Premium {' '}
                    {eventT == sportsKeyByName.CRICKET ? "Cricket" : eventT == sportsKeyByName.TENNIS ? "Tennis" : eventT == sportsKeyByName.SOCCER ? "Soccer" : ""}
                </span>
                        <a id="sportsBookRules" className="btn-head_rules">Rules</a>
                    </h4>
                    {(eventT == sportsKeyByName.CRICKET && !hideFancyTabBtn) &&
                        <a id="showFancyBetBtn" className="other-tab" onClick={handleFancy}>Fancy Bet</a>}
                    <a id="minMaxBtn_1" href="#" className="btn-fancy_info" style={{display: 'none'}}>Min/Max</a>
                    <a id="minMaxBtn_2" href="#" className="btn-fancy_info" style={{}}>Min</a>
                    <div id="minMaxWrap_1" className="fancy_info-popup" style={{display: 'none'}}>
                        <dl>
                            <dt>Min/Max</dt>
                            <dd id="minMaxInfo_1">0.00</dd>
                        </dl>
                        <dl>
                            <dt id="rebateName_1">Rebate</dt>
                            <dd id="rebateRatio_1">0.00%</dd>
                        </dl>
                        {/*<a onClick="javascript: $j(this).parent().hide();" href="#" className="close">Close</a>*/}
                    </div>
                    <div id="minMaxWrap_2" className="fancy_info-popup" style={{display: 'none'}}>
                        <dl>
                            <dt>Min</dt>
                            <dd id="minMaxInfo_2">10.00</dd>
                        </dl>
                        <dl>
                            <dt id="rebateName_2" style={{display: 'none'}}>Rebate</dt>
                            <dd id="rebateRatio_2" style={{display: 'none'}}>0.00%</dd>
                        </dl>
                        {/*<a onclick="javascript: $j(this).parent().hide();" href="#" className="close">Close</a>*/}
                    </div>
                </div>
            )}

        </>
    )
}

export default FencyPremuimTabController;

